export default __webpack_public_path__ + "static/media/javascript-game-thumbnail.50ca521b.png";